<template>
	<div class="boxBg">
		<div class="echart" ref="echart_div"></div>
	</div>
</template>

<script>
import echarts from 'echarts';
export default {
	props: {
		analysisData: {
			type: Object //可指定接收类型，如:Array.
		}
	},
	data() {
		return {
			wid: 0
		};
	},
	mounted() {
		this.wid = sessionStorage.getItem('wid') || 0;
		this.longBar();
	},
	methods: {
		longBar() {
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				 title: {
				    text: this.analysisData.title,
				    subtext: ''
				},
				xAxis: {
					type: 'category',
					data: this.analysisData.axisTitle
				},
				yAxis: {
					
					type: 'value'
				},
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				series: [
					{
						data: this.analysisData.seriesData,
						type: 'bar',
						showBackground: true,
						barWidth: 50,
					}
				]
			};
			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		}
	}
};
</script>

<style scoped="scoped" lang="scss">
	.boxBg {
		margin-top: 20px;
		background-color: #ffffff;
		padding: 10px;
	}
.echart {
	width: 90%;
	height: 400px;
	margin: 20px auto;
}
</style>
